import { useMemo, useState } from "react";
import { AppBarComponent } from "../Components/AppBar";
import { MaterialReactTable } from "material-react-table";
import { Box, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import "../0.styles.css";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import { TextFieldDisabled } from "../Components/TextFieldDisabled";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  config,
  functions,
  instance,
  validateFunction,
} from "../Components/config";
import { useLocation, useNavigate } from "react-router-dom";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function UsuarioInformacion() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = state;
  const [isLoading, setLoading] = useState(true);
  const [userInfo, setUserIfno] = useState({
    correo: "",
    nombre: "",
    apellido: "",
    area: "",
    fotografia: "",
    activo: 0,
  });
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = useState(false);
  const [activo, setActivo] = useState(userInfo.activo);
  const [actividades, setActividades] = useState([]);
  const { user } = useAuth();

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      size: 5,
    },
    {
      accessorKey: "upse",
      header: "UPSE",
      size: 20,
    },
    {
      accessorKey: "descripcion",
      header: "Descripción",
      size: 20,
    },
  ]);

  if (isLoading) {
    async function getUser() {
      try {
        const { data } = await instance.get("/users/getById/" + id);
        setUserIfno(data);
        setActivo(userInfo.activo);
      } catch (error) {
        alert(error);
      }
    }
    async function getActividades() {
      try {
        const { data } = await instance.get(
          "/actividad/getByResponsable/" + id
        );
        setActividades(data);
      } catch (error) {
        alert(error);
      }
    }
    getUser();
    getActividades();
    setLoading(false);
  }

  const handleSubmit = () => {
    instance
      .patch("/users/toggleActivate", {
        user: user.id,
        id: id,
        activo: userInfo.activo,
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: "Se ha actualizado correctamente el estado del usuario.",
        });
        setOpenDialog(true);
        setUserIfno({
          ...userInfo,
          activo: res.data.activo,
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="md"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                component="img"
                sx={{
                  cursor: "pointer",
                  width: {xs:"15vh", sm:"12vw"},
                  height: {xs:"15vh", sm:"12vw"},
                  borderRadius: "100%",
                  objectFit: "cover",
                }}
                src={config.profile_url + userInfo.fotografia}
                alt="user profile picture"
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled title="Nombre(s)" value={userInfo.nombre} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title="Apellido(s)"
                  value={userInfo.apellido}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled
                  title="Correo electrónico"
                  value={userInfo.correo}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldDisabled title="Área" value={userInfo.areaNombre} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <MaterialReactTable
              localization={MRT_Localization_ES}
              columns={columns}
              data={actividades}
              enableFullScreenToggle={false}
              enableColumnFilterModes={false}
              //enableColumnOrdering={false}
              enableGrouping={false}
              enablePinning={false}
              positionToolbarAlertBanner="none"
              enableDensityToggle={false}
              //enableFullScreenToggle={false}
              enableHiding={false}
              enablePagination={true}
              enableTopToolbar={true}
              enableBottomToolbar={true}
              enableRowActions
              positionActionsColumn="first"
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <Tooltip title="Más información">
                    <IconButton
                      color="primary"
                      onClick={() =>
                        navigate("/Actividad", {
                          state: { id: row.original.id },
                        })
                      }
                    >
                      <InfoTwoToneIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              initialState={{
                columnVisibility: { id: false },
                density: "comfortable",
                pagination: { pageSize: 5 },
              }}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  header: "", //change header text
                },
              }}
            />
          </Grid>
          <Grid item xs={0} sm={4} />
          {validateFunction(user, functions.ToggleUserState) && (
            <Grid item xs={12} sm={4}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                color={userInfo.activo === 0 ? "success" : "error"}
                onClick={() => handleSubmit()}
              >
                {userInfo.activo === 0 ? "Habilitar" : "Deshabilitar"}
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </LoaderBox>
  );
}
export { UsuarioInformacion };
